export const getAuth = state => state.auth;

export const getBarsarispp = state => state.barsarispp;

export const getEndpoints = state => state.endpoints;

export const getEndpointIndex = state => state.endpointIndex;

export const getResponse = state => state.response;



// WEBPACK FOOTER //
// ./src/store/getters.js